module.exports = __webpack_public_path__ + "static/media/heic-placeholder.9ac72808.svg";